
import { computed } from 'vue'
import { nativeToast } from '@/utils/nativeFn'
interface IQuetionTile {
  ansResStatus: number
  queId: string
  unAnswered: boolean
}
type IQueList = IQuetionTile[]
export default {
  name: 'AnswerSheet',
  props: {
    questionList: {
      type: Array,
      default: () => [{ queId: '', ansResStatus: -2 }] as IQueList
    },
    showButton: { type: Boolean, default: true },
    isAllDecidable: { type: Boolean, default: true },
    unAnsweredNum: { type: Number, default: 1 } // 周周练情况下固定为0。周周练可以不用全部答完提交
  },
  setup(props, { emit }) {
    const questionList = computed(() => props.questionList as IQueList)
    const handleTargetTile = (index) => emit('handleTargetTile', index)
    const handleSubmit = () => {
      if (props.unAnsweredNum) {
        nativeToast('全部答完才可提交')
      } else {
        emit('handleSubmit', 'answerSheet')
      }
    }
    const close = () => emit('close')
    return { questionList, handleTargetTile, handleSubmit, close }
  }
}
